import * as React from 'react';
import {
    Button,
    Modal,
    Row,
    Panel,
    Col,
    FormGroup,
    FormControl,
    ButtonGroup
} from 'react-bootstrap';
import { Link } from 'react-router-dom';
import DateTime from 'react-datetime';
import { Translate } from '../../shared/LanguageService';
import * as Features from '../../shared/Features';
import { ICalendarItemBasic, ICalendarItemType, ICalendarItemUserType } from '../calendar/Types';
import ProductPropertiesIcons from '../propertyIcons/ProductPropertiesIcons';
import ConfirmationModal from '../../components/common/ConfirmationModal';
import PhotographerCalendarApi from '../photographerCalendars/PhotographerCalendarApi';
import StylingUserCalendarApi from '../stylingUserPersonalCalendars/StylingUserCalendarApi';
import ImageProcessingActionsApi from '../orders/view/imageprocessing/api/ImageProcessingApi';
import DefinitionList from '../../components/common/DefinitionList';
import DefinitionRow from '../../components/common/DefinitionRow';
import GoogleMapsLink from '../../components/common/GoogleMapsLink';
import { shouldShowGoToOrderButton } from './utils/calendarUtils';
import { IImageProcessingComments } from '../orders/view/basicorderinfo/Types';
import { handleError } from '../../shared/ErrorCatching';
import notify from '../../shared/feedback/notifications';
import { CommentType } from '../orders/view/imageprocessing/Entities';
import { assign } from '../../shared/Assign';
import * as ProductProperty from '../../shared/ProductProperties';
import Loader from 'react-loader';
import moment from 'moment';

interface IProps {
    calendarItemBasic: ICalendarItemBasic;
    closeModal?: () => void;
    hideModal?: () => void;
    getSubPartUrlForOrderLink?: () => any;
    saveEvent?: (calendarItem?: any) => void;
    deleteEvent?: (calendarItem: any) => void;
    unbookEvent?: (item: number) => void;
    canUnbook?: boolean;
    canEdit?: boolean;
    calendarItemUserType: ICalendarItemUserType;
    user: any;
}

interface IState {
    calendarItemBasic: ICalendarItemBasic;
    calendarItem: any;
    showConfirmationModal: boolean;
    isLoading: boolean;
    eventId: number | null;
    imageProcessingComments: IImageProcessingComments;
}

class CalendarModal extends React.Component<IProps, IState> {
    constructor(props: IProps, context: IState) {
        super(props, context);
        this.state = {
            calendarItemBasic: {} as ICalendarItemBasic,
            calendarItem: {},
            showConfirmationModal: false,
            isLoading: true,
            eventId: null,
            imageProcessingComments: {
                internalComment: '',
                originalInternalComment: '',
                editInternalComment: false
            }
        };

        this.startDateChange = this.startDateChange.bind(this);
        this.endDateChange = this.endDateChange.bind(this);
        this.onChange = this.onChange.bind(this);
        this.openEditComment = this.openEditComment.bind(this);
        this.onChangeComment = this.onChangeComment.bind(this);
        this.cancelComment = this.cancelComment.bind(this);
        this.saveComment = this.saveComment.bind(this);
    }

    UNSAFE_componentWillMount() {
        if (!this.props.calendarItemBasic.userId) {
            this.setState({
                calendarItem: this.props.calendarItemBasic,
                isLoading: false
            } as IState);
        } else if (this.props.calendarItemUserType === ICalendarItemUserType.StylingUser) {
            StylingUserCalendarApi.getSpecificStylingUserCalendarItem(
                this.props.calendarItemBasic.userId,
                this.props.calendarItemBasic.id
            )
                .then((calendarItemDetailed: any) => {
                    let regEx = /\d{4}-\d{2}-\d{2}([a-zA-Z]|\s)\d{2}:\d{2}:\d{2}/;

                    let startDate = regEx.exec(calendarItemDetailed.start)[0];
                    let endDate = regEx.exec(calendarItemDetailed.end)[0];

                    calendarItemDetailed.start = startDate;
                    calendarItemDetailed.end = endDate;

                    this.setState({
                        calendarItem: calendarItemDetailed,
                        isLoading: false
                    } as IState);
                })
                .catch(() => {
                    this.setState({ isLoading: false } as IState);
                });
        } else {
            PhotographerCalendarApi.getSpecificPhotographerCalendarItem(
                this.props.calendarItemBasic.userId,
                this.props.calendarItemBasic.id
            )
                .then((calendarItemDetailed: any) => {
                    let regEx = /\d{4}-\d{2}-\d{2}([a-zA-Z]|\s)\d{2}:\d{2}:\d{2}/;

                    let startDate = regEx.exec(calendarItemDetailed.start)[0];
                    let endDate = regEx.exec(calendarItemDetailed.end)[0];

                    calendarItemDetailed.start = startDate;
                    calendarItemDetailed.end = endDate;

                    this.setState({
                        calendarItem: calendarItemDetailed,
                        isLoading: false
                    } as IState);
                })
                .catch(() => {
                    this.setState({ isLoading: false } as IState);
                });
        }
    }

    componentDidMount() {
        this.setState({
            calendarItemBasic: this.props.calendarItemBasic
        } as IState);
    }

    startDateChange(date: any) {
        let calendarItemNew = this.state.calendarItem;
        calendarItemNew.start = moment(date).format('YYYY-MM-DDTHH:mm:ss');

        this.setState({ calendarItem: calendarItemNew } as IState);
    }

    endDateChange(date: any) {
        let calendarItemNew = this.state.calendarItem;
        calendarItemNew.end = moment(date).format('YYYY-MM-DDTHH:mm:ss');

        this.setState({ calendarItem: calendarItemNew } as IState);
    }

    onChange(e: any) {
        let calendarItemNew: ICalendarItemBasic = this.state.calendarItem;

        if (e.target) {
            if (e.target.name === 'title') {
                calendarItemNew.title = e.target.value;
            } else if (e.target.name === 'description') {
                calendarItemNew.description = e.target.value;
            }

            this.setState({ calendarItem: calendarItemNew } as IState);
        }
    }

    openEditComment() {
        let imageProcessingComments = this.state.imageProcessingComments;
        imageProcessingComments.editInternalComment = true;
        imageProcessingComments.originalInternalComment =
            this.state.calendarItem.photographerInformationFromOrder;
        imageProcessingComments.internalComment =
            this.state.calendarItem.photographerInformationFromOrder;

        this.setState({
            imageProcessingComments: imageProcessingComments
        } as IState);
    }

    onChangeComment(e: any) {
        let imageProcessingComments = this.state.imageProcessingComments;
        if (e.target.name.startsWith('imageProcessingComments.')) {
            imageProcessingComments[e.target.name.replace('imageProcessingComments.', '')] =
                e.target.value;
            this.setState({
                imageProcessingComments: imageProcessingComments
            } as IState);
        }
    }

    cancelComment() {
        let imageProcessingComments = this.state.imageProcessingComments;
        imageProcessingComments.editInternalComment = false;
        imageProcessingComments.internalComment = imageProcessingComments.originalInternalComment;
        this.setState({
            imageProcessingComments: imageProcessingComments
        } as IState);
    }

    saveComment(text: string, type: number) {
        ImageProcessingActionsApi.updateImageProcessingComment(
            this.state.calendarItem.orderId,
            text,
            type
        )
            .then(() => {
                notify.success(Translate('image-processing/notification/comment-updated'));
                let imageProcessingComments = this.state.imageProcessingComments;
                imageProcessingComments.originalInternalComment =
                    imageProcessingComments.internalComment;
                imageProcessingComments.editInternalComment = false;

                let calendarItem = assign({}, this.state.calendarItem);
                calendarItem.photographerInformationFromOrder =
                    imageProcessingComments.internalComment;
                this.setState({
                    imageProcessingComments: imageProcessingComments,
                    calendarItem: calendarItem
                } as IState);
            })
            .catch((error: string) => handleError(error));
    }

    getTotalKeyPickupAddress() {
        const info = this.state.calendarItem ? this.state.calendarItem.bookableOrderInfo : null;

        if (!info) {
            return '';
        }

        const street = (info ? info.keyPickupAddress || '' : null).trim();
        const zip = (info ? info.keyPickupZip || '' : null).trim();
        const city = (info ? info.keyPickupCity || '' : null).trim();

        if (!street) {
            return '';
        }

        return [street, zip, city].filter(Boolean).join(', ').replace(', ', ' ');
    }

    render() {
        const productsToExclude = [ProductProperty.BlueSky, ProductProperty.InteriorBlueSky];

        const hasKeyPickupProperty = (this.state.calendarItem.productProperties || []).some((p: any) => p.value === ProductProperty.KeyPickup);

        const orderId: number | null = this.state.calendarItem.orderId
            ? this.state.calendarItem.orderId
            : null;

        return (
            <div>
                <Loader loaded={!this.state.isLoading} scale={2.0} />
                <div className={'order-loader' + (this.state.isLoading ? ' loader-on' : '')} />
                {this.state.showConfirmationModal && (
                    <ConfirmationModal
                        title={Translate('calendarmodal/confirmationmodal/title')}
                        text={Translate('calendarmodal/confirmationmodal/text')}
                        doButtonLabel={Translate('calendarmodal/confirmationmodal/do-button-label')}
                        cancelButtonLabel={Translate(
                            'calendarmodal/confirmationmodal/cancel-button-babel'
                        )}
                        doButtonStyle="danger"
                        do={() => {
                            if (this.state.eventId) {
                                this.props.unbookEvent(this.state.eventId);
                            }
                        }}
                        closeModal={() => {
                            this.setState({
                                showConfirmationModal: false
                            } as IState);
                        }}
                    />
                )}
                <Modal
                    bsSize="large"
                    show={true}
                    onHide={() => {
                        this.props.closeModal();
                    }}
                >
                    <Modal.Header closeButton>
                        {this.props.calendarItemBasic.id === -1 && (
                            <Modal.Title>
                                {Translate('calendarmodal/header/title/new-event')}
                            </Modal.Title>
                        )}
                        {this.state.calendarItem.orderNumber && (
                            <Modal.Title>
                                {Translate('calendarmodal/header/title/title')}{' '}
                                {this.state.calendarItem.orderNumber}{' '}
                                {this.state.calendarItem.productProperties && (
                                    <ProductPropertiesIcons
                                        properties={this.state.calendarItem.productProperties.filter(
                                            (property) => {
                                                return (
                                                    property.value !==
                                                    productsToExclude.find((x) => x === property.value)
                                                );
                                            }
                                        )}
                                        otherOrderId={this.state.calendarItem.orderId}
                                    ></ProductPropertiesIcons>
                                )}
                            </Modal.Title>
                        )}
                        {this.props.calendarItemBasic.id !== -1 &&
                            !this.state.calendarItem.orderNumber &&
                            this.state.calendarItem.editable === false && (
                                <Modal.Title>
                                    {Translate('calendarmodal/header/title/show-event')}{' '}
                                    {this.state.calendarItem.productProperties && (
                                        <ProductPropertiesIcons
                                            properties={this.state.calendarItem.productProperties.filter(
                                                (property) => {
                                                    return (
                                                        property.value !==
                                                        productsToExclude.find((x) => x === property.value)
                                                    );
                                                }
                                            )}
                                        ></ProductPropertiesIcons>
                                    )}
                                </Modal.Title>
                            )}
                        {this.props.calendarItemBasic.id !== -1 &&
                            !this.state.calendarItem.orderNumber &&
                            this.state.calendarItem.editable === true && (
                                <Modal.Title>
                                    {Translate('calendarmodal/header/title/edit-event')}{' '}
                                    {this.state.calendarItem.productProperties && (
                                        <ProductPropertiesIcons
                                            properties={this.state.calendarItem.productProperties.filter(
                                                (property) => {
                                                    return (
                                                        property.value !==
                                                        productsToExclude.find((x) => x === property.value)
                                                    );
                                                }
                                            )}
                                        ></ProductPropertiesIcons>
                                    )}
                                </Modal.Title>
                            )}
                    </Modal.Header>
                    <Modal.Body>
                        {/* Visa kalenderevent */}
                        {this.state.calendarItem.orderNumber && (
                            <div>
                                <Row>
                                    <Col sm={12}>
                                        <Panel>
                                            <Panel.Heading>
                                                <h3 className="panel-title">
                                                    {Translate(
                                                        'calendarmodal/panel-photographer-instructions/title/photographer-instructions'
                                                    )}
                                                </h3>
                                            </Panel.Heading>
                                            <Panel.Body>
                                                <table className="two-columns">
                                                    <tbody>
                                                        {!this.state.calendarItem.numberOfImages &&
                                                            this.state.calendarItem.title && (
                                                                <tr>
                                                                    <td className="table-title">
                                                                        {Translate(
                                                                            'calendarmodal/panel-photographer-instructions/label-packet'
                                                                        )}
                                                                        :
                                                                    </td>
                                                                    <td>
                                                                        {
                                                                            this.state.calendarItem
                                                                                .title
                                                                        }
                                                                    </td>
                                                                </tr>
                                                            )}
                                                        <tr>
                                                            <td className="table-title">
                                                                {Translate(
                                                                    'calendarmodal/panel-photographer-instructions/label-date'
                                                                )}
                                                                :
                                                            </td>
                                                            <td className="table-description">{`${moment(
                                                                this.state.calendarItem.start
                                                            ).format('L LT')} - ${
                                                                moment(
                                                                    this.state.calendarItem.start
                                                                ).isSame(
                                                                    moment(
                                                                        this.state.calendarItem.end
                                                                    ),
                                                                    'day'
                                                                )
                                                                    ? moment(
                                                                          this.state.calendarItem
                                                                              .end
                                                                      ).format('LT')
                                                                    : moment(
                                                                          this.state.calendarItem
                                                                              .end
                                                                      ).format('L LT')
                                                            }`}</td>
                                                        </tr>
                                                        {this.state.calendarItem.numberOfImages &&
                                                            this.state.calendarItem.numberOfImages >
                                                                0 && (
                                                                <tr>
                                                                    <td className="table-title">
                                                                        {Translate(
                                                                            'calendarmodal/panel-photographer-instructions/view-label/photographer-instructions/label-total-number-images'
                                                                        )}
                                                                        :
                                                                    </td>
                                                                    <td className="table-description">
                                                                        (
                                                                        {
                                                                            this.state.calendarItem
                                                                                .numberOfImages
                                                                        }{' '}
                                                                        {Translate(
                                                                            'calendarmodal/panel-photographer-instructions/view-label/photographer-instructions/images'
                                                                        )}
                                                                        )
                                                                    </td>
                                                                </tr>
                                                            )}
                                                        {this.state.calendarItem
                                                            .photographerInstructions &&
                                                            this.state.calendarItem
                                                                .photographerInstructions.length >
                                                                0 &&
                                                            this.state.calendarItem.photographerInstructions.map(
                                                                (x: any, i: number) => (
                                                                    <tr
                                                                        key={`photographer-instruction-${i}`}
                                                                    >
                                                                        <td className="table-title">
                                                                            "{x.productName}
                                                                            ":
                                                                        </td>
                                                                        <td className="table-description">
                                                                            {
                                                                                x.photographerInstructions
                                                                            }
                                                                        </td>
                                                                    </tr>
                                                                )
                                                            )}
                                                    </tbody>
                                                </table>
                                            </Panel.Body>
                                        </Panel>
                                    </Col>
                                </Row>
                                <Row>
                                    <div className="col-sm-4">
                                        <Panel>
                                            <Panel.Heading>
                                                <h3 className="panel-title">
                                                    {Translate(
                                                        'calendarmodal/panel-address/title/address'
                                                    )}
                                                </h3>
                                            </Panel.Heading>
                                            <Panel.Body>
                                                <DefinitionList>
                                                    <DefinitionRow
                                                        title={Translate('calendarmodal/panel-address/view-label/address-line-1')}
                                                        description={
                                                            <GoogleMapsLink
                                                                streetAddress={
                                                                    this.state.calendarItem
                                                                        .bookableOrderAddressInfo
                                                                        .address_line1
                                                                }
                                                                zip={
                                                                    this.state.calendarItem
                                                                        .bookableOrderAddressInfo.zip
                                                                }
                                                                city={
                                                                    this.state.calendarItem
                                                                        .bookableOrderAddressInfo.city
                                                                }
                                                            >
                                                                {
                                                                    this.state.calendarItem
                                                                        .bookableOrderAddressInfo
                                                                        .address_line1
                                                                }
                                                            </GoogleMapsLink>
                                                        }
                                                    />
                                                    <DefinitionRow
                                                        title={Translate('calendarmodal/panel-address/view-label/post-town')}
                                                        description={`${this.state.calendarItem.bookableOrderAddressInfo.zip}, ${this.state.calendarItem.bookableOrderAddressInfo.city}`}
                                                    />
                                                    <DefinitionRow
                                                        title={Translate('calendarmodal/panel-addresss/view-label/object-type')}
                                                        description={Translate(this.state.calendarItem.bookableOrderAddressInfo.objectType)}
                                                    />
                                                    <DefinitionRow
                                                        title={Translate('calendarmodal/panel-address/view-label/address-district')}
                                                        description={this.state.calendarItem.bookableOrderAddressInfo.district}
                                                        display={!this.state.calendarItem.bookableOrderInfo.isCommercial}
                                                    />
                                                    <DefinitionRow
                                                        title={Translate('calendarmodal/panel-address/view-label/object-area-square-meters')}
                                                        description={this.state.calendarItem.bookableOrderAddressInfo.objectAreaSquareMeters}
                                                        display={!this.state.calendarItem.bookableOrderInfo.isCommercial}
                                                    />
                                                    <DefinitionRow
                                                        title={Translate('calendarmodal/panel-address/view-label/object-number-of-rooms')}
                                                        description={this.state.calendarItem.bookableOrderAddressInfo.objectNumberOfRooms}
                                                        display={!this.state.calendarItem.bookableOrderInfo.isCommercial}
                                                    />
                                                    <DefinitionRow
                                                        title={Translate('calendarmodal/panel-address/view-label/contact-person')}
                                                        description={
                                                            this.state.calendarItem
                                                                .bookableOrderInfo
                                                                .availableContactPersons &&
                                                            Translate(
                                                                this.state.calendarItem.bookableOrderInfo.availableContactPersons.filter(
                                                                    (x: any) =>
                                                                        x.value ===
                                                                        this.state
                                                                        .calendarItem
                                                                        .bookableOrderInfo
                                                                        .contactPerson
                                                                )[0].displayName
                                                            )
                                                        }
                                                        display={!this.state.calendarItem.bookableOrderInfo.isCommercial}
                                                    />
                                                    <DefinitionRow
                                                        title={Translate('calendarmodal/panel-address/view-label/object-type/apartment/has-balcony')}
                                                        description={
                                                            this.state.calendarItem
                                                                .bookableOrderAddressInfo
                                                                .apartmentHasBalcony
                                                                ? Translate(
                                                                      'calendarmodal/panel-address/view-label/object-type/apartment/has-balcony/yes'
                                                                  )
                                                                : Translate(
                                                                      'calendarmodal/panel-address/view-label/object-type/apartment/has-balcony/no'
                                                                  )
                                                        }
                                                        display={
                                                            !this.state.calendarItem.bookableOrderInfo.isCommercial 
                                                            && this.state.calendarItem.bookableOrderAddressInfo.objectTypeId === 1
                                                        }
                                                    />
                                                    <DefinitionRow
                                                        title={Translate('calendarmodal/panel-address/view-label/object-type/apartment/floor')}
                                                        description={this.state.calendarItem.bookableOrderAddressInfo.apartmentFloor}
                                                        display={
                                                            !this.state.calendarItem.bookableOrderInfo.isCommercial 
                                                            && this.state.calendarItem.bookableOrderAddressInfo.objectTypeId === 1
                                                        }
                                                    />
                                                    <DefinitionRow
                                                        title={Translate('calendarmodal/panel-address/view-label/object-type/apartment/access-code')}
                                                        description={this.state.calendarItem.bookableOrderAddressInfo.apartmentAccessCode}
                                                        display={
                                                            !this.state.calendarItem.bookableOrderInfo.isCommercial 
                                                            && this.state.calendarItem.bookableOrderAddressInfo.objectTypeId === 1
                                                        }
                                                    />
                                                    <DefinitionRow
                                                        title={Translate('calendarmodal/panel-address/view-label/will-attend')}
                                                        description={
                                                            this.state.calendarItem
                                                                .bookableOrderInfo
                                                                .willAttendWhenPhotographing
                                                                ? Translate(
                                                                      'calendarmodal/panel-address/view-label/will-attend/yes'
                                                                  )
                                                                : Translate(
                                                                      'calendarmodal/panel-address/view-label/will-attend/no'
                                                                  )
                                                        }
                                                        display={this.props.calendarItemUserType === ICalendarItemUserType.Photographer}
                                                    />
                                                </DefinitionList>
                                            </Panel.Body>
                                        </Panel>
                                    </div>
                                    {this.state.calendarItem.bookableOrderInfo &&
                                        this.state.calendarItem.bookableOrderInfo
                                            .keyPickupAddress &&
                                        hasKeyPickupProperty && (
                                            <div className="col-sm-4">
                                                <Panel bsStyle="warning">
                                                    <Panel.Heading>
                                                        <h3 className="panel-title">
                                                            <i
                                                                className="material-icons"
                                                                style={{ marginRight: '4px' }}
                                                            >
                                                                vpn_key
                                                            </i>
                                                            {Translate(
                                                                'calendarmodal/panel-address/view-label/key-reminder-title'
                                                            )}
                                                        </h3>
                                                    </Panel.Heading>
                                                    <Panel.Body>
                                                        <strong>
                                                            {Translate(
                                                                'calendarmodal/panel-address/view-label/key-reminder-address'
                                                            )}
                                                        </strong>{' '}
                                                        <GoogleMapsLink
                                                            streetAddress={this.getTotalKeyPickupAddress()}
                                                        >
                                                            {this.getTotalKeyPickupAddress()}
                                                        </GoogleMapsLink>
                                                    </Panel.Body>
                                                </Panel>
                                            </div>
                                        )}
                                    <div className="col-sm-4">
                                        <Panel>
                                            <Panel.Heading>
                                                <h3 className="panel-title">
                                                    {Translate(
                                                        'calendarmodal/panel-owner-info/title/owner-info'
                                                    )}
                                                </h3>
                                            </Panel.Heading>
                                            <Panel.Body>
                                                <DefinitionList>
                                                    <DefinitionRow
                                                        title={Translate('calendarmodal/panel-owner-info/view-label/owner-first-name')}
                                                        description={this.state.calendarItem.bookableOrderOwnerContactInfo.firstName}
                                                    />
                                                    <DefinitionRow
                                                        title={Translate('calendarmodal/panel-owner-info/view-label/owner-last-name')}
                                                        description={this.state.calendarItem.bookableOrderOwnerContactInfo.lastName}
                                                    />
                                                    <DefinitionRow
                                                        title={Translate('calendarmodal/panel-owner-info/view-label/owner-primary-phone-number')}
                                                        description={this.state.calendarItem.bookableOrderOwnerContactInfo.primaryPhoneNumber}
                                                        display={Boolean(this.state.calendarItem.bookableOrderOwnerContactInfo.primaryPhoneNumber)}
                                                        isTelephoneLink
                                                    />
                                                    <DefinitionRow
                                                        title={Translate('calendarmodal/panel-owner-info/view-label/owner-secondary-phone-number')}
                                                        description={this.state.calendarItem.bookableOrderOwnerContactInfo.secondaryPhoneNumber}
                                                        display={Boolean(this.state.calendarItem.bookableOrderOwnerContactInfo.secondaryPhoneNumber)}
                                                        isTelephoneLink
                                                    />
                                                </DefinitionList>
                                            </Panel.Body>
                                        </Panel>
                                    </div>
                                    <div className="col-sm-4">
                                        <Panel>
                                            <Panel.Heading>
                                                <h3 className="panel-title">
                                                    {Translate(
                                                        'calendarmodal/panel-broker-info/title/broker-info'
                                                    )}
                                                </h3>
                                            </Panel.Heading>
                                            <Panel.Body>
                                                <DefinitionList>
                                                    <DefinitionRow
                                                        title={Translate('calendarmodal/panel-broker-info/view-label/broker/firm')}
                                                        description={this.state.calendarItem.bookableOrderBrokerContactInfo.company}
                                                    />
                                                    <DefinitionRow
                                                        title={Translate('calendarmodal/panel-broker-info/view-label/broker/name')}
                                                        description={this.state.calendarItem.bookableOrderBrokerContactInfo.fullName}
                                                    />
                                                    <DefinitionRow
                                                        title={Translate('calendarmodal/panel-broker-info/view-label/broker/primary-phone-number')}
                                                        description={this.state.calendarItem.bookableOrderBrokerContactInfo.primaryPhoneNumber}
                                                        display={Boolean(this.state.calendarItem.bookableOrderBrokerContactInfo.primaryPhoneNumber)}
                                                        isTelephoneLink
                                                    />
                                                    <DefinitionRow
                                                        title={Translate('calendarmodal/panel-broker-info/view-label/broker/secondary-phone-number')}
                                                        description={this.state.calendarItem.bookableOrderBrokerContactInfo.secondaryPhoneNumber}
                                                        display={Boolean(this.state.calendarItem.bookableOrderBrokerContactInfo.secondaryPhoneNumber)}
                                                        isTelephoneLink
                                                    />
                                                    <DefinitionRow
                                                        title={Translate('calendarmodal/panel-broker-info/view-label/broker/email')}
                                                        description={this.state.calendarItem.bookableOrderBrokerContactInfo.email}
                                                        display={Boolean(this.state.calendarItem.bookableOrderBrokerContactInfo.email)}
                                                    />
                                                </DefinitionList>
                                            </Panel.Body>
                                        </Panel>
                                    </div>
                                </Row>
                                <Row>
                                    <Col sm={4}>
                                        <Panel>
                                            <Panel.Heading>
                                                <h3 className="panel-title">
                                                    {Translate(
                                                        'calendarmodal/panel-info-from-order/title/photographer-information-from-order'
                                                    )}
                                                </h3>
                                                {Features.hasFeature(
                                                    Features.UpdateCommentsToStylingUser,
                                                    this.props.user
                                                ) && (
                                                    <Button
                                                        bsSize="small"
                                                        bsStyle="info"
                                                        className="btn-edit"
                                                        onClick={() => this.openEditComment()}
                                                    >
                                                        <i className="material-icons mode">edit</i>{' '}
                                                        {Translate(
                                                            'image-processing/page/comments/header/edit-comment'
                                                        )}
                                                    </Button>
                                                )}
                                            </Panel.Heading>
                                            <Panel.Body>
                                                {!this.state.imageProcessingComments
                                                    .editInternalComment &&
                                                    this.state.calendarItem
                                                        .photographerInformationFromOrder}
                                                {!this.state.imageProcessingComments
                                                    .editInternalComment &&
                                                    !this.state.calendarItem
                                                        .photographerInformationFromOrder && (
                                                        <span />
                                                    )}
                                                {this.state.imageProcessingComments
                                                    .editInternalComment && (
                                                    <div>
                                                        <FormGroup>
                                                            <FormControl
                                                                name="imageProcessingComments.internalComment"
                                                                componentClass="textarea"
                                                                value={
                                                                    this.state
                                                                        .imageProcessingComments
                                                                        .internalComment
                                                                }
                                                                onChange={this.onChangeComment}
                                                            />
                                                        </FormGroup>
                                                        <ButtonGroup className="pull-right">
                                                            <Button
                                                                onClick={() => this.cancelComment()}
                                                            >
                                                                {Translate(
                                                                    'image-processing/page/comment/button-label/cancel'
                                                                )}
                                                            </Button>
                                                            <Button
                                                                bsStyle="primary"
                                                                onClick={() =>
                                                                    this.saveComment(
                                                                        this.state
                                                                            .imageProcessingComments
                                                                            .internalComment,
                                                                        CommentType.TO_PHOTOGRAPHER
                                                                    )
                                                                }
                                                            >
                                                                {Translate(
                                                                    'image-processing/page/comment/button-label/save'
                                                                )}
                                                            </Button>
                                                        </ButtonGroup>
                                                    </div>
                                                )}
                                                {this.state.calendarItem.agentCommentToPhotographerFromOrder &&
                                                    this.state.calendarItem.agentCommentToPhotographerFromOrder.trim() && (
                                                        <>
                                                            <br />
                                                            <strong><em>{Translate('image-processing/page/comments/header/from-agent-to-photographer')}:</em></strong>
                                                            <br />
                                                            {this.state.calendarItem.agentCommentToPhotographerFromOrder}
                                                        </>
                                                    )}
                                            </Panel.Body>
                                        </Panel>
                                    </Col>
                                    {Features.hasFeature(
                                        Features.ViewInformationFromFirm,
                                        this.props.user
                                    ) && (
                                        <Col sm={4}>
                                            <Panel>
                                                <Panel.Heading>
                                                    <h3 className="panel-title">
                                                        {Translate(
                                                            'calendarmodal/panel-info-from-firm/title/information-from-firm'
                                                        )}
                                                    </h3>
                                                </Panel.Heading>
                                                <Panel.Body>
                                                    {this.state.calendarItem
                                                        .photographerInformationFromFirm ? (
                                                        this.state.calendarItem
                                                            .photographerInformationFromFirm
                                                    ) : (
                                                        <div>&nbsp;</div>
                                                    )}
                                                </Panel.Body>
                                            </Panel>
                                        </Col>
                                    )}
                                    {Features.hasFeature(
                                        Features.ViewInformationFromChain,
                                        this.props.user
                                    ) && (
                                        <Col sm={4}>
                                            <Panel>
                                                <Panel.Heading>
                                                    <h3 className="panel-title">
                                                        {Translate(
                                                            'calendarmodal/panel-info-from-chain/title/information-from-chain'
                                                        )}
                                                    </h3>
                                                </Panel.Heading>
                                                <Panel.Body>
                                                    {this.state.calendarItem
                                                        .photographerInformationFromChain ? (
                                                        this.state.calendarItem
                                                            .photographerInformationFromChain
                                                    ) : (
                                                        <div>&nbsp;</div>
                                                    )}
                                                </Panel.Body>
                                            </Panel>
                                        </Col>
                                    )}
                                </Row>
                            </div>
                        )}
                        {/* Visa redan inlagd oediterbar blocker */}
                        {(this.state.calendarItem.type === 4 ||
                            this.state.calendarItem.orderId === null) &&
                            !this.state.calendarItem.editable && (
                                <div>
                                    <Row>
                                        <Col sm={4}>
                                            <Panel>
                                                <Panel.Heading>
                                                    <h3 className="panel-title">
                                                        {Translate(
                                                            'calendarmodal/block/panel/title/event-title'
                                                        )}
                                                    </h3>
                                                </Panel.Heading>
                                                <Panel.Body>
                                                    {this.state.calendarItem.title}
                                                </Panel.Body>
                                            </Panel>
                                        </Col>
                                        <Col sm={4}>
                                            <Panel>
                                                <Panel.Heading>
                                                    <h3 className="panel-title">
                                                        {Translate(
                                                            'calendarmodal/block/panel/title/event-description'
                                                        )}
                                                    </h3>
                                                </Panel.Heading>
                                                <Panel.Body>
                                                    {this.state.calendarItem.description ? (
                                                        this.state.calendarItem.description
                                                    ) : (
                                                        <div>&nbsp;</div>
                                                    )}
                                                </Panel.Body>
                                            </Panel>
                                        </Col>
                                        <Col sm={4}>
                                            <Panel>
                                                <Panel.Heading>
                                                    <h3 className="panel-title">
                                                        {Translate(
                                                            'calendarmodal/block/panel/title/event-date'
                                                        )}
                                                    </h3>
                                                </Panel.Heading>
                                                <Panel.Body>
                                                    <div>
                                                        {moment
                                                            .utc(this.state.calendarItem.start)
                                                            .format('L LT')}{' '}
                                                        -
                                                        {moment
                                                            .utc(this.state.calendarItem.start)
                                                            .format('L') ===
                                                        moment
                                                            .utc(this.state.calendarItem.end)
                                                            .format('L')
                                                            ? ' ' +
                                                              moment
                                                                  .utc(this.state.calendarItem.end)
                                                                  .format('LT')
                                                            : ' ' +
                                                              moment
                                                                  .utc(this.state.calendarItem.end)
                                                                  .format('L LT')}
                                                    </div>
                                                </Panel.Body>
                                            </Panel>
                                        </Col>
                                    </Row>
                                </div>
                            )}
                        {/* Lägg till nytt kalender-event eller redigera ett egenditlagt sådant */}
                        {(this.state.calendarItem.id === -1 ||
                            (this.state.calendarItem.type === 4 &&
                                this.state.calendarItem.editable)) && (
                            <div>
                                <Row>
                                    <Col sm={3}>
                                        <Panel>
                                            <Panel.Heading>
                                                <h3 className="panel-title">
                                                    {Translate(
                                                        'calendarmodal/block/panel/title/event-type'
                                                    )}
                                                </h3>
                                            </Panel.Heading>
                                            <Panel.Body>
                                                <FormGroup
                                                    controlId="eventType"
                                                    className="required"
                                                >
                                                    <FormControl
                                                        type="text"
                                                        name="type"
                                                        disabled={true}
                                                        value={Translate(
                                                            'photographer/modal/form/calendar/event-type/' +
                                                                ICalendarItemType[
                                                                    this.state.calendarItemBasic
                                                                        .type
                                                                ]
                                                        )}
                                                    />
                                                </FormGroup>
                                            </Panel.Body>
                                        </Panel>
                                    </Col>
                                    <Col sm={4}>
                                        <Panel>
                                            <Panel.Heading>
                                                <h3 className="panel-title">
                                                    {Translate(
                                                        'calendarmodal/block/panel/title/event-title'
                                                    )}
                                                </h3>
                                            </Panel.Heading>
                                            <Panel.Body>
                                                <FormGroup
                                                    controlId="eventTitle"
                                                    className="required"
                                                >
                                                    <FormControl
                                                        type="text"
                                                        name="title"
                                                        disabled={!this.props.canEdit}
                                                        value={this.state.calendarItem.title}
                                                        onChange={this.onChange}
                                                    />
                                                </FormGroup>
                                            </Panel.Body>
                                        </Panel>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm={12}>
                                        <Panel>
                                            <Panel.Heading>
                                                <h3 className="panel-title">
                                                    {Translate(
                                                        'calendarmodal/block/panel/title/event-description'
                                                    )}
                                                </h3>
                                            </Panel.Heading>
                                            <Panel.Body>
                                                <FormGroup controlId="eventDescription">
                                                    <FormControl
                                                        type="text"
                                                        name="description"
                                                        disabled={!this.props.canEdit}
                                                        value={this.state.calendarItem.description}
                                                        onChange={this.onChange}
                                                    />
                                                </FormGroup>
                                            </Panel.Body>
                                        </Panel>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm={6}>
                                        <Panel>
                                            <Panel.Heading>
                                                <h3 className="panel-title">
                                                    {Translate(
                                                        'calendarmodal/block/panel/title/event-start'
                                                    )}
                                                </h3>
                                            </Panel.Heading>
                                            <Panel.Body>
                                                <FormGroup
                                                    controlId="eventStart"
                                                    className="required"
                                                >
                                                    <DateTime
                                                        locale={moment.locale()}
                                                        value={moment
                                                            .utc(this.state.calendarItem.start)
                                                            .format('L LT')}
                                                        onChange={this.startDateChange}
                                                        onFocus={() =>
                                                            document
                                                                .getElementById('rdt-event-start')
                                                                .blur()
                                                        }
                                                        inputProps={{
                                                            id: 'rdt-event-start',
                                                            disabled: !this.props.canEdit
                                                        }}
                                                    />
                                                </FormGroup>
                                            </Panel.Body>
                                        </Panel>
                                    </Col>
                                    <Col sm={6}>
                                        <Panel>
                                            <Panel.Heading>
                                                <h3 className="panel-title">
                                                    {Translate(
                                                        'calendarmodal/block/panel/title/event-end'
                                                    )}
                                                </h3>
                                            </Panel.Heading>
                                            <Panel.Body>
                                                <FormGroup
                                                    controlId="eventEnd"
                                                    className="required"
                                                >
                                                    <DateTime
                                                        className="rdtCalendarEventEnd"
                                                        locale={moment.locale()}
                                                        value={moment
                                                            .utc(this.state.calendarItem.end)
                                                            .format('L LT')}
                                                        onChange={this.endDateChange}
                                                        onFocus={() =>
                                                            document
                                                                .getElementById('rdt-event-end')
                                                                .blur()
                                                        }
                                                        inputProps={{
                                                            id: 'rdt-event-end',
                                                            disabled: !this.props.canEdit
                                                        }}
                                                    />
                                                </FormGroup>
                                            </Panel.Body>
                                        </Panel>
                                    </Col>
                                </Row>
                            </div>
                        )}
                    </Modal.Body>
                    <Modal.Footer>
                        {this.state.calendarItem.id > -1 && (
                            <Button
                                onClick={() => {
                                    this.props.hideModal();
                                }}
                            >
                                {Translate('calendarmodal/footer/button/close')}
                            </Button>
                        )}
                        {shouldShowGoToOrderButton(orderId, this.props.user) ? (
                            <Link
                                className="btn btn-default"
                                to={`/orders/${
                                    this.state.calendarItem.orderId
                                }${this.props.getSubPartUrlForOrderLink()}`}
                            >
                                {Translate('calendarmodal/footer/button/goto-order')}
                            </Link>
                        ) : null}
                        {this.state.calendarItem.editable &&
                            this.props.canEdit &&
                            this.state.calendarItem.id === -1 && (
                                <Button
                                    bsStyle="danger"
                                    onClick={() => {
                                        this.props.hideModal();
                                    }}
                                >
                                    {Translate('calendarmodal/footer/button/abort')}
                                </Button>
                            )}
                        {this.state.calendarItem.editable && this.props.canEdit && (
                            <Button
                                bsStyle="primary"
                                onClick={() => {
                                    this.props.saveEvent(this.state.calendarItem);
                                }}
                            >
                                {Translate('calendarmodal/footer/button/save')}
                            </Button>
                        )}
                        {this.state.calendarItem.editable &&
                            this.props.canEdit &&
                            this.state.calendarItem.id > -1 && (
                                <Button
                                    bsStyle="danger"
                                    onClick={() => {
                                        this.props.deleteEvent(this.state.calendarItem);
                                    }}
                                >
                                    {Translate('calendarmodal/footer/button/delete')}
                                </Button>
                            )}
                        {this.props.canUnbook === true && !this.state.calendarItem.editable && (
                            <Button
                                bsStyle="danger"
                                onClick={() => {
                                    this.setState({
                                        showConfirmationModal: true
                                    } as IState);
                                }}
                            >
                                {Translate('calendarmodal/footer/button/unbookEvent')}
                            </Button>
                        )}
                    </Modal.Footer>
                </Modal>
            </div>
        );
    }
}

export default CalendarModal;
